import React from 'react';
import { HeadingWithBody, TileSelect } from '@99designs/spa-common';
import { STEP_PRODUCT_PREFERENCES } from '../constants';
import type { Option } from '@99designs/spa-common';
import type { StepComponentProps } from '../../components/Onboarder/Config';
import type { SelectedValues } from '../config';

export type ProductPreferences =
    | 'colors-fonts'
    | 'website'
    | 'social-media'
    | 'brand-guidelines'
    | 'brochures'
    | 'stationery'
    | 'product-packaging'
    | 'signage'
    | 'product-labels'
    | 'business-cards'
    | 'other';

export const productPreferences = (): Record<ProductPreferences, string> => ({
    'colors-fonts': __('Colors and fonts'),
    website: __('Website'),
    'social-media': __('Social media'),
    'brand-guidelines': __('Brand guidelines'),
    brochures: __('Brochures'),
    stationery: __('Stationery'),
    'product-packaging': __('Product packaging'),
    signage: __('Signage'),
    'product-labels': __('Product labels'),
    'business-cards': __('Business cards'),
    other: __('Other'),
});

export function ProductPreferencesStepInputs({
    data,
    onChange,
}: StepComponentProps<SelectedValues>) {
    const toggleOption = (value: ProductPreferences, name: string) => {
        const selected = data[name] || [];

        if (!Array.isArray(selected)) {
            return;
        }

        const newSelection = selected.includes(value)
            ? selected.filter((item) => item !== value)
            : [...selected, value];

        if (newSelection.length === 0) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [name]: emit, ...rest } = data;
            onChange(rest);
            return;
        }

        const newData: SelectedValues = {
            ...data,
            [name]: newSelection,
        };
        onChange(newData);
    };

    const productPreferencesArray = Object.entries(productPreferences()) as [
        ProductPreferences,
        string
    ][];

    const tileOptions: Option<ProductPreferences>[] = productPreferencesArray.map(
        ([value, heading]) => ({
            label: <HeadingWithBody heading={heading} />,
            value,
        })
    );

    return (
        <TileSelect<ProductPreferences>
            name={STEP_PRODUCT_PREFERENCES}
            value={data.product_preferences || []}
            options={tileOptions}
            onChange={(value, name) => {
                toggleOption(value, name);
            }}
            isMulti
        />
    );
}
